import { useState, useEffect, SyntheticEvent } from 'react';

import CircularProgressProps from './type';
import {
  WrapperStyled,
  LabelStyled,
  CenterContentStyled,
  CircleLoadingStyled,
  ColoredExtraBackgroundStyled,
  LoadingGraphStyled,
  ContentImage,
  ContentBackground,
  BorderContentBackground,
} from './styled';

const CircularProgress = ({ ...props }: CircularProgressProps) => {
  const { value, size, photoSrc, loadingMode: loadingProp, onClick, circleSize, ...rest } = props;
  const [loading, setLoading] = useState(loadingProp);

  useEffect(() => {
    setLoading(loadingProp);
  }, [loadingProp]);

  const handleClick = (event: SyntheticEvent<HTMLDivElement>) => {
    onClick(event);
  };

  return (
    <WrapperStyled data-testid="circularProgressWrapper" size={size} onClick={handleClick}>
      <LabelStyled>
        <p>{`${value}%`}</p>
      </LabelStyled>
      <CircleLoadingStyled
        {...rest}
        size={size}
        value={value}
        circleSize={circleSize}
        loadingMode={loading}
      />

      <ColoredExtraBackgroundStyled loadingMode={loading} />
      <LoadingGraphStyled
        data-testid="circularProgressBar"
        {...rest}
        value={value}
        loadingMode={loading}
      />

      <CenterContentStyled>
        <BorderContentBackground>
          <ContentBackground loadingMode={loading} />
        </BorderContentBackground>
        <ContentImage photoSrc={photoSrc} />
      </CenterContentStyled>
    </WrapperStyled>
  );
};

CircularProgress.defaultProps = {
  CircularProgress: false,
  value: 0,
};

export default CircularProgress;
